import { createSelector } from '@reduxjs/toolkit';
import { moduleNamespace } from '@Store/config.store';
import {
	Category,
	Component,
	ComponentMetadata,
	ComponentType,
	MultiParamCell,
	NamespacedStoreState,
} from '@Types';
import { useSelector } from 'react-redux';

const parseNamespace = (state: NamespacedStoreState) => state[moduleNamespace];

export const CoFStoreSelector = createSelector(
	parseNamespace,
	state => state.CoFConfig,
);

export const CoFConfigChanged = createSelector(
	CoFStoreSelector,
	cofStore => cofStore.isChanged,
);

export const CoFComponentFieldsSelector = createSelector(
	CoFStoreSelector,
	cofStore => cofStore.componentFields,
);

export const selectCofStore = () => useSelector(CoFStoreSelector);

export const selectorCoFConfigChanged = () => useSelector(CoFConfigChanged);

export const selectCoFComponentFields = () =>
	useSelector(CoFComponentFieldsSelector);

export const selectorMaxCoFValue = createSelector(
	CoFStoreSelector,
	cofStore => {
		let maxValue = 10;

		cofStore.categories.forEach((category: Category) => {
			category.components.forEach((component: Component) => {
				if (component.select) {
					if (
						component.type === ComponentType.MultiParam &&
						component.scoreMatrix
					) {
						component.scoreMatrix.forEach(
							(data: MultiParamCell) => {
								if (data.score > maxValue)
									maxValue = data.score;
							},
						);
					} else if (component.metadata) {
						component.metadata.forEach(
							(data: ComponentMetadata) => {
								if (data.value > maxValue)
									maxValue = data.value;
							},
						);
					}
				}
			});
		});

		return maxValue;
	},
);

export const selectMaxCoFValue = (): number => useSelector(selectorMaxCoFValue);
